// Generated by ts-to-zod
import { z } from 'zod';

export const messageSchema = z.object({
  type: z.union([z.literal('error'), z.literal('warning'), z.literal('info')]),
  content: z.string(),
  id: z
    .union([z.literal('all'), z.string(), z.number()])
    .optional()
    .nullable(),
  detail: z
    .object({
      hookId: z.number().optional().nullable(),
      hookName: z.string().optional(),
      requestId: z.string().optional(),
      isException: z.boolean().optional(),
      tracebackLineNumber: z.number().optional(),
      ruleId: z.number().optional(),
      ruleName: z.string().optional(),
      sourceId: z.number().optional(),
      sourceSchemaId: z.string().optional(),
      timestamp: z.string().optional(),
    })
    .optional()
    .nullable(),
});
